// Thin blog index. Full post content lives in static HTML at /Public/blog/<slug>/index.html
// (served directly by Cloudflare Pages with full SEO + schema). This array only powers
// the homepage "Latest from the Blog" preview cards. Do NOT add post bodies here.

interface BlogPostMeta {
  id: number; slug: string; title: string; category: string;
  date: string; author: string; readTime: string; image: string;
  isoDate: string; desc: string;
}

export const blogPosts: BlogPostMeta[] = [
  {
    id: 1, slug: "raagengine-creator-pro-plans-2026",
    title: "RaagEngine is now 100% free — unlimited AI music prompts",
    category: "Product Update", date: "Apr 22, 2026", author: "RaagEngine Team", readTime: "4 min read",
    image: "https://picsum.photos/seed/productupdate/800/400", isoDate: "2026-04-22",
    desc: "RaagEngine is now completely free — unlimited generations, all 8 platforms, no credit card, no subscription. Here's what changed.",
  },
  {
    id: 2, slug: "how-to-make-money-with-ai-music",
    title: "How to Make Money with AI-Generated Music in 2026",
    category: "Monetisation", date: "Apr 19, 2026", author: "RaagEngine Team", readTime: "8 min read",
    image: "https://picsum.photos/seed/monetise/800/400", isoDate: "2026-04-19",
    desc: "YouTube AdSense, Spotify streaming, Content ID, sync licensing — the complete guide to building a sustainable income stream with AI music.",
  },
  {
    id: 3, slug: "suno-prompt-guide",
    title: "The complete guide to Suno AI prompts — what actually works",
    category: "Suno Guide", date: "Apr 15, 2026", author: "RaagEngine Team", readTime: "12 min read",
    image: "https://picsum.photos/seed/sunoprompt/800/400", isoDate: "2026-04-15",
    desc: "BPM, mood language, instrument combinations, character limits — everything you need to know to master Suno AI.",
  },
  {
    id: 4, slug: "indian-classical-youtube-niche",
    title: "Why Indian classical AI music is the best YouTube niche right now",
    category: "YouTube Niche", date: "Apr 12, 2026", author: "RaagEngine Team", readTime: "6 min read",
    image: "https://picsum.photos/seed/indianniche/800/400", isoDate: "2026-04-12",
    desc: "Low competition, high engagement, global audience — and RaagEngine is built for it.",
  },
  {
    id: 5, slug: "meditation-music-youtube-channel",
    title: "How to start a meditation music YouTube channel with AI",
    category: "YouTube Niche", date: "Apr 9, 2026", author: "RaagEngine Team", readTime: "7 min read",
    image: "https://picsum.photos/seed/meditationchannel/800/400", isoDate: "2026-04-09",
    desc: "Step-by-step guide to launching a meditation music channel using AI tools — from first upload to monetisation.",
  },
  {
    id: 6, slug: "suno-to-spotify-7-steps",
    title: "From Suno to Spotify in 7 steps",
    category: "Distribution", date: "Apr 5, 2026", author: "RaagEngine Team", readTime: "5 min read",
    image: "https://picsum.photos/seed/sunospotify/800/400", isoDate: "2026-04-05",
    desc: "The exact workflow to go from a Suno AI generation to a live Spotify track — including DistroKid metadata.",
  },
  {
    id: 7, slug: "lofi-channel-earnings",
    title: "How much do lo-fi YouTube channels actually earn?",
    category: "Monetisation", date: "Apr 2, 2026", author: "RaagEngine Team", readTime: "6 min read",
    image: "https://picsum.photos/seed/lofiearn/800/400", isoDate: "2026-04-02",
    desc: "Real earnings data from lo-fi music channels — CPM rates, watch time benchmarks, and what it takes to hit $1K per month.",
  },
  {
    id: 8, slug: "copyright-free-music-youtube-guide",
    title: "Copyright-Free Music for YouTube — The Complete 2026 Guide",
    category: "Creator Guide", date: "Mar 28, 2026", author: "RaagEngine Team", readTime: "9 min read",
    image: "https://picsum.photos/seed/copyrightfree/800/400", isoDate: "2026-03-28",
    desc: "What 'copyright-free' actually means, how Content ID works, why AI-generated music is the safest option, and a step-by-step guide to creating your channel soundtrack.",
  },
  {
    id: 9, slug: "suno-ai-prompt-raag-darbari",
    title: "Suno AI Prompt Raag Darbari: Dark, Introspective Classical Music",
    category: "Indian Classical", date: "Jun 1, 2026", author: "RaagEngine Team", readTime: "7 min read",
    image: "https://picsum.photos/seed/darbari/800/400", isoDate: "2026-06-01",
    desc: "Master Suno AI prompts for Raag Darbari. Generate dark ambient, orchestral fusion, and contemplative Hindustani classical music with sample prompts.",
  },
  {
    id: 10, slug: "suno-ai-prompt-raag-bhairavi",
    title: "Suno AI Prompt Raag Bhairavi: Create Hindustani Music",
    category: "Indian Classical", date: "May 31, 2026", author: "RaagEngine Team", readTime: "7 min read",
    image: "https://picsum.photos/seed/bhairavi/800/400", isoDate: "2026-05-31",
    desc: "Master Suno AI prompts for raag bhairavi. Create authentic Hindustani classical music with AI, featuring sample prompts and practical techniques.",
  },
  {
    id: 11, slug: "suno-ai-prompt-for-meditation-music",
    title: "Suno AI Prompt for Meditation Music: Calm, Focus & Sleep",
    category: "Meditation", date: "May 31, 2026", author: "RaagEngine Team", readTime: "6 min read",
    image: "https://picsum.photos/seed/meditation2/800/400", isoDate: "2026-05-31",
    desc: "The best Suno AI prompt for meditation music — copy-paste prompts for deep calm, focus, sleep and healing, plus raga, frequency and instrument tips.",
  },
  {
    id: 12, slug: "suno-ai-prompt-hindi",
    title: "Suno AI Prompt Hindi: हिंदी गाने के लिए परफेक्ट प्रॉम्प्ट कैसे लिखें",
    category: "Hindi Guide", date: "May 31, 2026", author: "RaagEngine Team", readTime: "7 min read",
    image: "https://picsum.photos/seed/hindiprompt/800/400", isoDate: "2026-05-31",
    desc: "Suno AI prompt hindi में कैसे लिखें — Bollywood, romantic, bhajan और Punjabi गानों के लिए copy-paste प्रॉम्प्ट और Devanagari लिरिक्स टिप्स।",
  },
  {
    id: 13, slug: "suno-ai-prompt-raag-yaman",
    title: "Suno AI Prompt Raag Yaman: Majestic Evening Classical Music",
    category: "Indian Classical", date: "Jun 2, 2026", author: "RaagEngine Team", readTime: "7 min read",
    image: "https://picsum.photos/seed/raagyaman/800/400", isoDate: "2026-06-02",
    desc: "Master Suno AI prompts for Raag Yaman. Generate majestic orchestral fusion and powerful Hindustani classical music with sample prompts and techniques.",
  },
  {
    id: 14, slug: "suno-ai-prompt-raag-shivaranjani",
    title: "Suno AI Prompt Raag Shivaranjani: Sweet Devotional Classical Music",
    category: "Indian Classical", date: "Jun 2, 2026", author: "RaagEngine Team", readTime: "7 min read",
    image: "https://picsum.photos/seed/shivaranjani/800/400", isoDate: "2026-06-02",
    desc: "Master Suno AI prompts for Raag Shivaranjani. Generate devotional, warm, and spiritually uplifting classical music with sample prompts and techniques.",
  },
  {
    id: 15, slug: "suno-ai-prompt-mode-francais",
    title: "Suno AI Prompt Mode Francais : Dorien, Phrygien, Lydien et Plus",
    category: "French Guide", date: "Jun 2, 2026", author: "RaagEngine Team", readTime: "8 min read",
    image: "https://picsum.photos/seed/modefrancais/800/400", isoDate: "2026-06-02",
    desc: "Guide complet pour créer de la musique modale avec Suno AI — Dorien, Phrygien, Lydien, Mixolydien — avec prompts prêts à copier.",
  },
  {
    id: 16, slug: "suno-ai-prompt-flamenco",
    title: "Suno AI Prompt Flamenco: Crea Música Auténtica con IA",
    category: "Spanish Guide", date: "Jun 2, 2026", author: "RaagEngine Team", readTime: "8 min read",
    image: "https://picsum.photos/seed/flamenco/800/400", isoDate: "2026-06-02",
    desc: "Guía completa para crear flamenco auténtico con Suno AI — palos, escalas, técnicas de guitarra flamenca y prompts listos para copiar.",
  },
  {
    id: 17, slug: "suno-ai-prompt-dastgah-irani",
    title: "Suno AI Prompt Dastgah Irani: موسیقی کلاسیک فارسی با هوش مصنوعی",
    category: "Persian Guide", date: "Jun 2, 2026", author: "RaagEngine Team", readTime: "8 min read",
    image: "https://picsum.photos/seed/dastgah/800/400", isoDate: "2026-06-02",
    desc: "راهنمای کامل ساخت موسیقی کلاسیک ایرانی با Suno AI — دستگاه شور، چهارگاه، ماهور با پرامپت‌های آماده.",
  },
  {
    id: 18, slug: "suno-ai-raag-bhairavi-hindi-prompt",
    title: "Suno AI Raag Bhairavi Hindi Prompt: भैरवी राग से भावपूर्ण संगीत बनाएं",
    category: "Hindi Guide", date: "Jun 2, 2026", author: "RaagEngine Team", readTime: "8 min read",
    image: "https://picsum.photos/seed/bhairavihindi/800/400", isoDate: "2026-06-02",
    desc: "Suno AI में राग भैरवी के लिए हिंदी गाइड — copy-paste prompts, रस, instruments और advanced techniques हिंदी में।",
  },
  {
    id: 19, slug: "suno-ai-prompt-nihon-ongaku-scale",
    title: "Suno AI Prompt Nihon Ongaku Scale: ヨナ抜き・都節・琉球音階で和風音楽を作る",
    category: "Japanese Guide", date: "Jun 2, 2026", author: "RaagEngine Team", readTime: "8 min read",
    image: "https://picsum.photos/seed/nihonongaku/800/400", isoDate: "2026-06-02",
    desc: "Suno AIで本格的な日本音楽を作る完全ガイド — ヨナ抜き、都節、琉球音階のコピペ用プロンプトと応用テクニック。",
  },
  {
    id: 20, slug: "suno-ai-prompt-maqam-arabi",
    title: "Suno AI Prompt Maqam Arabi: إنشاء موسيقى عربية أصيلة بالذكاء الاصطناعي",
    category: "Arabic Guide", date: "Jun 2, 2026", author: "RaagEngine Team", readTime: "8 min read",
    image: "https://picsum.photos/seed/maqamarabi/800/400", isoDate: "2026-06-02",
    desc: "دليل شامل لإنشاء موسيقى عربية أصيلة بـSuno AI — مقامات راست وبياتي وحجاز مع برومبتات جاهزة للنسخ.",
  },
  {
    id: 21, slug: "suno-ai-prompt-blues-scale",
    title: "Suno AI Prompt Blues Scale: Create Authentic Blues, Jazz and Rock Music with AI",
    category: "Blues Guide", date: "Jun 2, 2026", author: "RaagEngine Team", readTime: "8 min read",
    image: "https://picsum.photos/seed/bluesscale/800/400", isoDate: "2026-06-02",
    desc: "Complete guide to blues scale prompts for Suno AI — Delta blues, Chicago blues, jazz blues, and blues rock with copy-paste prompts.",
  },
  {
    id: 22, slug: "suno-ai-prompt-escalas-brasileiras",
    title: "Suno AI Prompt Escalas Brasileiras: Samba, Bossa Nova e Música Nordestina com IA",
    category: "Portuguese Guide", date: "Jun 2, 2026", author: "RaagEngine Team", readTime: "8 min read",
    image: "https://picsum.photos/seed/escalasbrasileiras/800/400", isoDate: "2026-06-02",
    desc: "Guia completo para criar samba, bossa nova, forró e música nordestina autêntica com Suno AI — prompts prontos e técnicas avançadas.",
  },
];
